<section class="detail-section">
  <div class="section-header-row">
    <h3 class="section-title">{{ title }}</h3>
    <button
      mat-icon-button
      type="button"
      class="section-toggle"
      (click)="toggle()">
      <mat-icon>{{ expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
    @if (showChangeIndicator) {
      <mat-icon
        class="change-indicator"
        [matTooltip]="'DEAD_LETTERS.DETAIL.VALUES.FIELDS_CHANGED' | translate">
        sync_problem
      </mat-icon>
    }
  </div>

  @if (expanded) {
    <ng-content></ng-content>
  }
</section>
